import api from "./index";

export interface FinalDocumentParams {
  number?: string;
  registerNumber?: string;
  documentTypeIds?: Array<string>;
  categoryIds?: Array<string>;
  companyId?: string;
  ownerId?: string;
  protocolsIds?: Array<string>;
  coursesIds?: Array<string>;
  listenersIds?: Array<string>;
  status?: 1 | 0;
  documentOfRetraining?: string;
  internship?: string;
  graduateWork?: string;
  numberDocumentOfRetraining?: string;
  registerNumberDocumentOfRetraining?: string;
  issuedAtMin?: Date;
  issuedAtMax?: Date;
  expirationMin?: Date;
  expirationMax?: Date;
  expirationNullable?: boolean;
  isSignedAt?: boolean;
  signedAtMin?: Date;
  signedAtMax?: Date;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  isArchive?: boolean;
  archivedAtMin?: Date;
  archivedAtMax?: Date;
  isFisFrdoExported?: boolean;
  fisFrdoExportedAtMin?: Date;
  fisFrdoExportedAtMax?: Date;
  fisFrdoType?: "professional.education" | "additional.professional.education";
  offset?: number;
  limit?: number;
  sort?:
    | "createdAt"
    | "updatedAt"
    | "signedAt"
    | "issuedAt"
    | "expiration"
    | "number"
    | "originalSeries"
    | "registerNumber";
  order?: "ASC" | "DESC";
  options?: any;
}

/**
 * Decorator of UserApi.list method.
 * @param params
 */
export default (params: FinalDocumentParams) => {
  return api.FinalDocumentApi.listShort(
    params.number,
    params.registerNumber,
    params.documentTypeIds,
    params.categoryIds,
    params.companyId,
    params.ownerId,
    params.protocolsIds,
    params.coursesIds,
    params.listenersIds,
    params.status,
    params.documentOfRetraining,
    params.internship,
    params.graduateWork,
    params.numberDocumentOfRetraining,
    params.registerNumberDocumentOfRetraining,
    params.issuedAtMin,
    params.issuedAtMax,
    params.expirationMin,
    params.expirationMax,
    params.expirationNullable,
    params.isSignedAt,
    params.signedAtMin,
    params.signedAtMax,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.isArchive,
    params.archivedAtMin,
    params.archivedAtMax,
    params.isFisFrdoExported,
    params.fisFrdoExportedAtMin,
    params.fisFrdoExportedAtMax,
    params.fisFrdoType,
    params.offset,
    params.limit,
    params.sort,
    params.order,
    params.options
  );
};
